import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import "./styles.scss";
import * as actionTypes from "../../../store/actions/types";
import {
  Button,
  ButtonIcon,
  CategoryCardExtraSmall,
  Input,
  SelectBox,
  SelectionCheckbox,
  Tag,
  UploadCard,
} from "../../../components";
import { Scrollbars } from "react-custom-scrollbars";
import { AutoComplete, Spin, Tabs } from "antd";
import { getCategory, uploadImage } from "../../../api";
import MerchantCardExtraSmall from "../../../components/Element/MerchantCardExtraSmall";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import uuid from "react-uuid";
import { GetIcon } from "../../../config/icon";
import { convertToRaw } from "draft-js";
import { setValue } from "../../../components/UI/RichTextBox/redux/rich-textbox-action";
import { NewMerchant } from "../../modal";
import {
  cooFindMerchantById,
  cooFindMerchantByName,
  cooGetAllMerchantByPage,
} from "../../merchant/service/merchant.service";
import ReactCrop from "react-image-crop";
import { OpenNotification } from "../../../config/notification";
import { checkValidity } from "../../../utils";
import moment from "moment";

const { TabPane } = Tabs;

const SampathBankOffers = (props) => {
  const dispatch = useDispatch();

  const {
    value,
    selectedOfferData,
    createdMerchant,
    isOpenCreateNewMerchant,
    selectMerchant,
    selectedBank,
    userData,
  } = useSelector((state) => ({
    value: state.richTextBox.value,
    createdMerchant: state.merchantReducer.createdMerchant,
    isOpenCreateNewMerchant: state.merchantReducer.isOpenCreateNewMerchant,
    selectedOfferData: state.offerReducer.selectedOfferData,
    selectedBank: state.offerReducer.selectedBank,
    selectMerchant: state.merchantReducer.selectMerchant,
    userData: state.userReducer.userData,
  }));

  const [merchantList, setMerchantList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageViewCount, setPageViewCount] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [viewPointHeight, setViewPointHeight] = useState(window.innerHeight);
  const [viewPointWidth, setViewPointWidth] = useState(window.innerWidth);
  const [src, setSrc] = useState(null);
  const [merchantData, setMerchantData] = useState(null);
  const [categoryData, setCategoryData] = useState(null);
  const [cardTypes, setCardTypes] = useState([]);
  const [bankData, setBankData] = useState("");
  const [merchantLocationList, setMerchantLocationList] = useState([]);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [editorState, setEditorState] = useState(null);
  const [draftHTMLValue, setDraftHTMLValue] = useState("");
  const [showFull, setShowFull] = useState(false);
  const [showFullLocation, setShowFullLocation] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState([]);
  const [mobileNoList, setMobileNoList] = useState("");
  const [emailList, setEmailList] = useState("");
  const imageRef = useRef();

  const [dataForm, setDataForm] = useState({
    searchMerchant: {
      key: "searchMerchant",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Search merchant here...",
      },
      value: "",
      validation: {
        required: false,
      },
      valid: false,
      touched: false,
      label: "",
    },
    searchCategory: {
      key: "searchCategory",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Search category here...",
      },
      value: "",
      validation: {
        required: false,
      },
      valid: false,
      touched: false,
      label: "",
    },
    offerTitle: {
      key: "offerTitle",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Ex : hotel name, Restaurant name",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Offer title",
    },
    offerHeader: {
      key: "offerHeader",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Ex : hotel name, Restaurant name",
        maxLength: "100",
      },
      value: "",
      validation: {
        required: true,
        maxLength: "100",
      },
      valid: false,
      touched: false,
      label: "offer Header",
    },
    offerRate: {
      key: "offerRate",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Offer Rate (%) ",
    },
    offerType: {
      key: "offerType",
      elementType: "",
      elementConfig: {
        type: "text",
        placeholder: "",
        options: [
          { id: uuid(), value: "off", isActive: false },
          { id: uuid(), value: "upto", isActive: false },
          { id: uuid(), value: "discount", isActive: false },
          { id: uuid(), value: "customize", isActive: false },
        ],
        disabled: false,
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Offer category",
    },
    promoCode: {
      key: "promoCode",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Promo Code",
    },
    offerValidity: {
      key: "offerValidity",
      elementType: "select",
      elementConfig: {
        type: "text",
        placeholder: "",
        options: [
          { id: uuid(), key: "fromTo", value: "From - To" },
          { id: uuid(), key: "until", value: "Until" },
          { id: uuid(), key: "till", value: "till" },
          { id: uuid(), key: "on", value: "on" },
          { id: uuid(), key: "customize", value: "Customize" },
          { id: uuid(), key: "other", value: "Other" },
        ],
        disabled: false,
      },
      value: "fromTo",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Offer Validity",
    },
    logoURL: {
      key: "logoURL",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "",
        disabled: false,
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "",
    },
    referenceURL: {
      key: "referenceURL",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "",
        disabled: false,
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Reference URL",
    },
    endDate: {
      key: "endDate",
      elementType: "datePicker",
      elementConfig: {
        label: "End Date",
        size: "md",
        width: "100%",
        placeholder: "DD-MM-YYYY",
      },
      value: "",
      dateValue: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "End date",
    },
    startDate: {
      key: "startDate",
      elementType: "datePicker",
      elementConfig: {
        label: "End Date",
        size: "md",
        width: "100%",
        placeholder: "DD-MM-YYYY",
      },
      value: "",
      dateValue: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Start date",
    },
    validDate: {
      key: "validDate",
      elementType: "datePicker",
      elementConfig: {
        type: "text",
        placeholder: "Valid date",
        disabled: false,
      },
      value: "",
      dateValue: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Valid date",
    },
    startTime: {
      key: "startTime",
      elementType: "timePicker",
      elementConfig: {
        type: "text",
        placeholder: "Valid time",
        disabled: false,
      },
      value: "",
      timeValue: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Start time",
    },
    endTime: {
      key: "endTime",
      elementType: "timePicker",
      elementConfig: {
        type: "text",
        placeholder: "Valid time",
        disabled: false,
      },
      value: "",
      timeValue: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "End time",
    },
    validTimeDateDescription: {
      key: "validTimeDateDescription",
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Ex : Happy hour",
        disabled: false,
      },
      value: "",
      validation: {
        required: false,
      },
      valid: false,
      label: "Valid (Time/Date) Description",
    },
    tag: {
      key: "tag",
      elementType: "select",
      elementConfig: {
        type: "text",
        placeholder: "Ex : ABC Hotel ",
        tag: [],
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Merchant",
    },
    termsAndConditions: {
      key: "termsAndConditions",
      elementType: "hasTag",
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      label: "Terms and conditions",
    },
  });

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const setAllData = async () => {
    if (merchantList.length === 0) {
      let resMerchant = await cooGetAllMerchantByPage({
        pageNo: pageNo,
        pageSize: 10,
      });

      const merchantList = resMerchant.data?.data || [];

      if (resMerchant.data?.data && resMerchant.data?.data.length > 0) {
        setPageNo((prev) => prev + 1);
        setMerchantList((prev) => [...prev, ...merchantList]);
        setTotalCount(resMerchant.data?.totalCount || 0);
        setHasMore(resMerchant.data?.data.length >= 10);
      }
    }
    if (categoryList.length === 0) {
      let resCategory = await getCategory();
      const categoryList = resCategory.data;
      if (resCategory.data && resCategory.data.length > 0) {
        setCategoryList(categoryList);
      }
    }
  };

  const onChangePage = async (pageNo, pageSize) => {
    if (isLoading || !hasMore) return;

    setIsLoading(true);
    setPageViewCount(pageSize);

    try {
      let res = await cooGetAllMerchantByPage({
        pageNo: pageNo,
        pageSize: pageSize,
      });
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setMerchantList((prev) => [...prev, ...res.data.data]);
        // setPageNo((prev) => prev + 1);
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
      } else {
        setHasMore(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setIsLoading(false);
    }
  };

  const handleMerchantSelect = (merchant) => {
    setMerchantData((prev) =>
      prev?.merchantId === merchant.merchantId ? null : merchant
    );
    dispatch({
      type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL,
      payload: merchant,
    });
  };

  const handleCategorySelect = (category) => {
    setCategoryData((prev) =>
      prev?.categoryId === category.categoryId ? null : category
    );
  };

  //==== Input Handle Change
  const inputHandleChange = (event, inputIdentity) => {
    let val = null;
    const updateForm = { ...dataForm };
    const updatedFormElement = { ...updateForm[inputIdentity] };
    let formatDate = "";
    if (
      inputIdentity === "startDate" ||
      inputIdentity === "endDate" ||
      inputIdentity === "validDate"
    ) {
      const parsedDate = moment(event._d, "YYYY-MM-DD");

      formatDate = parsedDate.format("YYYY-MM-DD");
    }
    if (inputIdentity === "startTime" || inputIdentity === "endTime") {
      const parsedDate = moment(event._d, "DD-MM-YYYY");

      formatDate = parsedDate.format("YYYY-MM-DD");
    }
    switch (inputIdentity) {
      case "endDate":
        let dat_val = moment(event._d).format("YYYY-MM-DD");
        //console.log("inputHandleChange", moment(event._d).format("DD-MM-YYYY"));
        updatedFormElement.value = event;
        updatedFormElement.dateValue = dat_val;
        break;
      case "startDate":
        let sdat_val = moment(event._d).format("YYYY-MM-DD");
        updatedFormElement.value = event;
        updatedFormElement.dateValue = sdat_val;
        break;
      case "validDate":
        let vdat_val = moment(event._d).format("YYYY-MM-DD");
        updatedFormElement.value = event;
        updatedFormElement.dateValue = vdat_val;
        break;
      case "startTime":
        let stime_val = moment(event._d).format("h:mm a");
        updatedFormElement.value = event;
        updatedFormElement.timeValue = stime_val;
        break;
      case "endTime":
        let etime_val = moment(event._d).format("h:mm a");
        updatedFormElement.value = event;
        updatedFormElement.timeValue = etime_val;
        break;
      default:
        updatedFormElement.value = event.target.value;
    }
    updatedFormElement.valid = checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updateForm[inputIdentity] = updatedFormElement;
    let formIsValid = true;
    for (let inputIdentifier in updateForm) {
      formIsValid = updateForm[inputIdentifier].valid && formIsValid;
    }
    setDataForm(updateForm);
  };

  const autoCompleteInputHandleChange = (event, key) => {
    const updatedDataForm = {
      ...dataForm,
      [key]: {
        ...dataForm[key],
        value: event,
        touched: true,
      },
    };
    setDataForm(updatedDataForm);
  };

  const fetchSuggestions = async (query) => {
    if (query === "") {
      setMerchantList([]);
      setIsLoading(true);
      let resMerchant = await cooGetAllMerchantByPage({
        pageNo: 1,
        pageSize: 10,
      });

      const merchants = resMerchant.data?.data || [];

      if (resMerchant.data?.data && resMerchant.data?.data.length > 0) {
        // setPageNo((prev) => prev + 1);
        setMerchantList(merchants);
        setTotalCount(resMerchant.data?.totalCount || 0);
        setHasMore(resMerchant.data?.data.length >= 10);
        setIsLoading(false);
      }
      return;
    }
    try {
      const response = await cooFindMerchantByName(query?.trim());
      const suggestions = response?.data?.data;
      //setState({ option: suggestions });
      if (response?.data?.data?.length > 0) {
        setMerchantList(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const toBase64 = async () => {
    const file = document.querySelector("#eventImageUpload").files[0];
    let result_base64 = await new Promise((resolve) => {
      let fileReader = new FileReader();
      fileReader.onload = (e) => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });

    uploadingImage(result_base64);
  };

  const uploadingImage = async (base64) => {
    setIsImageUploading(true);
    let res = await uploadImage(base64, "offer", "Offer");
    if (res && res.data && res.data.status) {
      const updateForm = { ...dataForm };
      updateForm["logoURL"].value = res.data.data.URL;
      setDataForm(updateForm);
      setIsImageUploading(false);
      setSrc("");
    } else {
      setIsImageUploading(true);
    }
  };

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      toBase64(reader.result);
    }
  };

  const onClickClearImage = () => {
    const updateForm = { ...dataForm };
    updateForm["logoURL"].value = "";
    setDataForm(updateForm);
    setIsImageUploading(false);
    setSrc(null);
  };

  const updateFormValidity = (inputIdentity) => {
    const updatedForm = { ...dataForm };
    const updatedFormElement = updatedForm[inputIdentity];
    updatedFormElement.valid = checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updatedForm[inputIdentity] = updatedFormElement;
    setDataForm(updatedForm);
  };

  const clearAll = async () => {
    const updateForm = { ...dataForm };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].valid = false;
      updateForm[key].touched = false;
      if (key === "startDate" || key === "endDate" || key === "validDate") {
        updateForm[key].dateValue = "";
      }
      if (key === "startTime" || key === "endTime") {
        updateForm[key].timeValue = "";
      }
    }
    setMerchantData("");
    // setCardTypes([]);
    setCategoryData("");
    setMerchantLocationList([]);
    setMobileNoList([]);
    setEmailList([]);
    setDataForm(updateForm);
  };

  const onClickSaveData = async () => {
    setIsLoading(false);

    const selectedBank = bankData;
    const selectCategory = categoryData;
    const selectMerchant = merchantData;

    const newDataForm = { ...dataForm };

    // Validate required fields

    if (newDataForm.offerTitle?.value === "") {
      updateFormValidity(newDataForm.offerTitle.key);
    }

    if (newDataForm.offerHeader?.value === "") {
      updateFormValidity(newDataForm.offerHeader.key);
    }

    if (newDataForm.offerRate?.value === "") {
      updateFormValidity(newDataForm.offerRate.key);
    }

    if (newDataForm.logoURL?.value === "") {
      updateFormValidity(newDataForm.logoURL.key);
    }

    if (!selectCategory) {
      OpenNotification("Error", "Please select Category!", "error");
    }

    if (merchantLocationList?.length === 0) {
      OpenNotification("Error", "Please select valid location!", "error");
    }

    if (!selectMerchant) {
      OpenNotification("Error", "Please select Merchant!", "error");
    }

    if (!selectedBank) {
      OpenNotification("Error", "Please select Bank!", "error");
    }

    //  if (termsAndConditions.length === 0) {
    //    updateFormValidity(newDataForm.termsAndConditions.key);
    //  }

    const offerValidity = newDataForm["offerValidity"].value;

    if (offerValidity === "fromTo") {
      updateFormValidity(newDataForm.startDate.key);
      updateFormValidity(newDataForm.endDate.key);
    } else if (["until", "till", "on", "other"].includes(offerValidity)) {
      updateFormValidity(newDataForm.endDate.key);
      if (offerValidity === "other") {
        updateFormValidity(newDataForm.validTimeDateDescription.key);
      }
    } else if (offerValidity === "customize") {
      updateFormValidity(newDataForm.validDate.key);
      updateFormValidity(newDataForm.startTime.key);
      updateFormValidity(newDataForm.endTime.key);
      updateFormValidity(newDataForm.validTimeDateDescription.key);
    }

    // Date validation error messages
    if (offerValidity === "fromTo") {
      if (!newDataForm.startDate.valid && !newDataForm.endDate.valid) {
        return OpenNotification(
          "Error",
          "Offer valid date is required (start/end-date)",
          "error"
        );
      }
      if (!newDataForm.startDate.valid) {
        return OpenNotification(
          "Error",
          "Offer valid date is required (start-date)",
          "error"
        );
      }
      if (!newDataForm.endDate.valid) {
        return OpenNotification(
          "Error",
          "Offer valid date is required (end-date)",
          "error"
        );
      }
    }

    if (
      ["until", "till", "on", "other"].includes(offerValidity) &&
      !newDataForm.endDate.valid
    ) {
      return OpenNotification(
        "Error",
        "Offer valid date is required!",
        "error"
      );
    }

    if (offerValidity === "customize") {
      if (!newDataForm.validDate.valid) {
        return OpenNotification(
          "Error",
          "Offer valid date is required!",
          "error"
        );
      }
      if (!newDataForm.startTime.valid) {
        return OpenNotification("Error", "Start time is required!", "error");
      }
      if (!newDataForm.endTime.valid) {
        return OpenNotification("Error", "End time is required!", "error");
      }
    }

    // Final validation before sending
    if (
      newDataForm.offerTitle.valid &&
      newDataForm.offerRate.valid &&
      selectedBank &&
      // termsAndConditions.length &&
      newDataForm.offerHeader.valid &&
      userData
    ) {
      setIsLoading(true);

      const terms = termsAndConditions;
      //  terms[selectedBank.bankId] = termsAndConditions;

      const body = {
        userId: userData?.userId,
        category: selectCategory,
        merchant: selectMerchant,
        bank: selectedBank,
        label: newDataForm.offerTitle.value,
        header: newDataForm.offerHeader.value,
        bannerImageURL: newDataForm.logoURL.value,
        referenceURL: newDataForm.referenceURL.value,
        offerType: newDataForm.offerType.value,
        offerRate: newDataForm.offerRate.value,
        offerDateType: offerValidity,
        offerStart: newDataForm.startDate.dateValue,
        offerEnd: newDataForm.endDate.dateValue,
        description: value ? value.payload : draftHTMLValue,
        cardTypes: cardTypes,
        validDate: newDataForm.validDate.dateValue,
        startTime: newDataForm.startTime.timeValue,
        endTime: newDataForm.endTime.timeValue,
        validTimeDateDescription: newDataForm.validTimeDateDescription.value,
        termsConditions: {
          [selectedBank.bankId]: terms,
        },
        location: merchantLocationList,
        hotLine: {
          mobileNo: mobileNoList,
          email: emailList,
        },
        customizeDate: {
          endDate: newDataForm.endDate.dateValue,
          description: newDataForm.validTimeDateDescription.value,
        },
        promoCode: newDataForm.promoCode.value,
        status: "accepted",
      };
      dispatch({
        type: actionTypes.OPEN_OFFER_CREATE_MODAL,
        payload: body,
      });
      //  props.onClickOpenOfferView(body);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      OpenNotification("Error", "Invalid data", "error");
    }
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const draftHTMLValue = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setDraftHTMLValue(draftHTMLValue);

    setValue(draftHTMLValue);
  };

  const onSelectCard = (selectedCardId) => {
    const updatedCardTypes = [...cardTypes].map((cardType) => {
      if (cardType.id === selectedCardId) {
        return {
          ...cardType,
          isActive: !cardType.isActive, // Toggle selected card
        };
      }
      return cardType;
    });

    setCardTypes(updatedCardTypes);
  };

  const selectAllCardTypes = () => {
    const updateCardTypes = [...cardTypes];
    for (let idx = 0; idx < updateCardTypes.length; idx++) {
      if (updateCardTypes[idx].isActive) {
        updateCardTypes[idx].isActive = false;
      } else {
        updateCardTypes[idx].isActive = true;
      }
    }
    setCardTypes(updateCardTypes);
  };

  const selectAllLocation = () => {
    const updateLocations = [...merchantLocationList];
    for (let idx = 0; idx < updateLocations.length; idx++) {
      if (updateLocations[idx].isActive) {
        updateLocations[idx].isActive = false;
      } else {
        updateLocations[idx].isActive = true;
      }
    }
    setMerchantLocationList(updateLocations);
  };

  const selectAllTerms = () => {
    let terms = { ...termsAndConditions };

    const updatedTermsConditions = termsAndConditions.map((term, index) => ({
      ...term,
      isActive: !term.isActive,
    }));

    terms[bankData?.bankId] = updatedTermsConditions;

    // this.props.onLoadTermsAndCondition(terms);

    setTermsAndConditions(updatedTermsConditions);
  };

  const onSelectLocation = (selectedCardId) => {
    const updatedCardTypes = [...merchantLocationList].map((cardType) => {
      if (cardType.id === selectedCardId) {
        return {
          ...cardType,
          isActive: !cardType.isActive, // Toggle selected card
        };
      }
      return cardType;
    });

    setMerchantLocationList(updatedCardTypes);
  };

  const onSelectOffer = (_item, i) => {
    const updateForm = { ...dataForm };
    updateForm["offerType"].value = _item?.value;
    setDataForm(updateForm);
  };

  const onSelectOption = (_item, key) => {
    const updateForm = { ...dataForm };
    updateForm[key].value = _item?.key;
    setDataForm(updateForm);
  };

  const onRemove = (key) => {
    const updateForm = { ...dataForm };
    updateForm[key].value = "";
    setDataForm(updateForm);
  };

  const onClickTermsAndConditions = (i) => {
    let terms = { ...termsAndConditions };

    const updatedTermsConditions = termsAndConditions.map((term, index) => ({
      ...term,
      isActive: index === i ? !term.isActive : term.isActive,
    }));

    terms[bankData?.bankId] = updatedTermsConditions;

    // this.props.onLoadTermsAndCondition(terms);

    setTermsAndConditions(updatedTermsConditions);
  };

  useEffect(() => {
    if (selectMerchant?.hotLine) {
      setMobileNoList(selectMerchant?.hotLine?.mobileNo);
      setEmailList(selectMerchant?.hotLine?.email);
    } else {
      setMobileNoList([]);
      setEmailList([]);
    }
    if (selectMerchant?.merchantId) {
      let locationList =
        selectMerchant?.location?.map((location) => ({
          ...location,
          isActive:
            merchantLocationList?.find(
              (curr) => curr.value === (location.value || location.tagName)
            )?.isActive || false,
        })) || [];
      setMerchantLocationList(locationList);
    }
    if (selectMerchant?.termsAndCondition && bankData?.bankId) {
      setTermsAndConditions(
        selectMerchant?.termsAndCondition[bankData?.bankId]
      );
    }
  }, [selectMerchant]);

  useEffect(() => {
    if (createdMerchant?.merchantId) {
      setMerchantData(createdMerchant);
      setDataForm((prev) => ({
        ...prev,
        logoURL: { ...prev.logoURL, value: createdMerchant.logoURL },
      }));
    }
  }, [createdMerchant]);

  useEffect(() => {
    if (merchantData === "") {
      setMerchantLocationList([]);
      setMobileNoList([]);
      setEmailList([]);
      setTermsAndConditions([]);
      return;
    }
    if (merchantData?.merchantId) {
      let locationList =
        merchantData?.location?.map((location) => ({
          ...location,
          isActive: false,
        })) || [];
      setMerchantLocationList(locationList);
    }
    if (merchantData?.hotLine) {
      setMobileNoList(merchantData?.hotLine?.mobileNo);
      setEmailList(merchantData?.hotLine?.email);
    }
    if (merchantData?.termsAndCondition && bankData?.bankId) {
      setTermsAndConditions(merchantData?.termsAndCondition[bankData?.bankId]);
    }
  }, [merchantData]);

  useEffect(() => {
    const loadData = async () => {
      setAllData();
    };
    loadData();
    if (props?.bankData) {
      setBankData(props.bankData);
      let cardTypes =
        props.bankData?.cardTypes?.map((card) => ({
          ...card,
          isActive: false,
        })) || [];

      setCardTypes(cardTypes);
    }
  }, []);

  useEffect(() => {
    if (selectedBank?.bankId) {
      let currentCardTypes = [...cardTypes];
      const updateCardTypes =
        selectedBank?.cardTypes?.length > 0
          ? selectedBank?.cardTypes.map((cardType) => {
              const foundCardType = currentCardTypes.find(
                (curr) => curr.value === (cardType.value || cardType.cardName)
              );
              return {
                id: cardType.id,
                value: cardType.value || cardType.cardName,
                count: cardType.count,
                isActive: foundCardType
                  ? foundCardType.isActive
                  : cardType.isActive,
              };
            })
          : [];

      setBankData(selectedBank);
      setCardTypes(updateCardTypes);
    }
  }, [selectedBank]);

  const cardTypesList = showFull ? cardTypes : cardTypes.slice(0, 5);
  const locationList = showFullLocation
    ? merchantLocationList
    : merchantLocationList.slice(0, 4);

  return (
    <>
      {/*----- image crop section wrapper ------*/}

      {isOpenCreateNewMerchant && <NewMerchant />}
      <div className="bank__wrap">
        <div className="bw__merchant d-flex flex-column">
          <div className="bwm__title d-flex justify-content-between">
            <div className="bwmt__header">Merchant</div>
            <div
              className="bwmt__action"
              onClick={() =>
                dispatch({ type: actionTypes.OPEN_CREATE_NEW_MERCHANT })
              }
            >
              Create New
            </div>
          </div>
          <AutoComplete
            value={dataForm.searchMerchant.value}
            // options={merchantOption}
            style={{ width: "100%", marginRight: "8px" }}
            onChange={(event) =>
              autoCompleteInputHandleChange(event, dataForm.searchMerchant.key)
            }
            onSearch={async (e) => {
              await fetchSuggestions(e);
            }}
            placeholder="Search merchant"
          />

          <Scrollbars
            onScroll={handleOnScroll}
            renderView={(props) => (
              <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
            )}
            style={{ height: viewPointHeight - 230 }}
          >
            {merchantList
              .filter((m) =>
                m.merchantName
                  .toLowerCase()
                  .includes(dataForm.searchMerchant.value.toLowerCase())
              )
              .map((m, i) => (
                <MerchantCardExtraSmall
                  key={m.merchantId}
                  merchantName={m.merchantName}
                  logo={m.logoURL}
                  merchantId={m.merchantId}
                  isSelect={merchantData?.merchantId === m.merchantId}
                  onClick={() => handleMerchantSelect(m)}
                />
              ))}
            {isLoading && (
              <div
                className={
                  "console__load-more-wrp d-flex justify-content-center mt-3 mb-3"
                }
              >
                <Spin />
              </div>
            )}
            {!isLoading && hasMore && (
              <div
                className={
                  "console__load-more-wrp d-flex justify-content-center mt-3 mb-3"
                }
              >
                <Button
                  size="sm"
                  type="btn-primary light"
                  onClick={onChangePage.bind(this, pageNo + 1, 10)}
                  text={
                    "Load more" + ` (${totalCount - pageNo * pageViewCount})`
                  }
                />
              </div>
            )}
          </Scrollbars>
        </div>
        <div className="bw__category d-flex flex-column">
          <div className="bwc__title">
            <div className="bwct__header">Category</div>
          </div>
          <AutoComplete
            value={dataForm.searchCategory.value}
            style={{ width: "100%" }}
            onChange={(value) =>
              autoCompleteInputHandleChange(value, dataForm.searchCategory.key)
            }
            placeholder="Search category"
          />
          <Scrollbars style={{ height: viewPointHeight - 230 }} autoHide>
            {categoryList
              .filter((c) =>
                c.categoryName
                  .toLowerCase()
                  .includes(dataForm.searchCategory.value.toLowerCase())
              )
              .map((c) => (
                <CategoryCardExtraSmall
                  key={c.categoryId}
                  categoryName={c.categoryName}
                  categoryId={c.categoryId}
                  isSelect={categoryData?.categoryId === c.categoryId}
                  onClick={() => handleCategorySelect(c)}
                />
              ))}
          </Scrollbars>
        </div>
        <div className={"bw__profile d-flex flex-column"}>
          <div className={"bwp__title d-flex flex-row justify-content-between"}>
            <div className={"bwpt__header"}>Basic profile</div>
          </div>
          <div className={"group-form"}>
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 300 }}
            >
              <UploadCard
                title={"Basic profile"}
                onSelectFile={(e) => onSelectFile(e)}
                isImageUploading={isImageUploading}
                logoURL={dataForm.logoURL.value}
              />
              <div className={"d-flex mb-1"}>
                <Button
                  text={"find image (google)"}
                  type={"btn-edit"}
                  size={"sm secondary mr-2"}
                  onClick={() => {
                    window.open(
                      `http://www.google.com/search?q=${
                        selectMerchant && selectMerchant.merchantName
                      }`,
                      "_blank"
                    );
                  }}
                />
              </div>

              {/*{!dataForm.logoURL.value &&}*/}
              {dataForm.logoURL.value && (
                <div className={"cco__offer-image-banner-wrapper mb-4"}>
                  <img
                    style={{
                      overflow: "hidden",
                      objectFit: "contain",
                    }}
                    src={dataForm.logoURL.value}
                  />

                  <div className={"cco__image-delete-wrapper"}>
                    <ButtonIcon
                      onClick={() => onClickClearImage()}
                      buttonIcon={GetIcon("close")}
                      type={"close"}
                      size={"md"}
                    />
                  </div>
                </div>
              )}
              <Input
                elementConfig={dataForm.logoURL.elementConfig}
                elementType={dataForm.logoURL.elementType}
                required={dataForm.logoURL.validation.required}
                isValid={!dataForm.logoURL.valid}
                touched={dataForm.logoURL.touched}
                value={dataForm.logoURL.value}
                isShowRequired={false}
                size={"md"}
                margin={"m-b-2"}
                label={dataForm.logoURL.label}
                changed={(event) =>
                  inputHandleChange(event, dataForm.logoURL.key)
                }
              />
              <Input
                elementConfig={dataForm.offerTitle.elementConfig}
                elementType={dataForm.offerTitle.elementType}
                required={dataForm.offerTitle.validation.required}
                isValid={!dataForm.offerTitle.valid}
                touched={dataForm.offerTitle.touched}
                value={dataForm.offerTitle.value}
                isShowRequired={true}
                size={"md"}
                margin={"m-b-1"}
                label={dataForm.offerTitle.label}
                changed={(event) =>
                  inputHandleChange(event, dataForm.offerTitle.key)
                }
              />
              {/* {tags && (
                <>
                  <div className={"multiple-line-wrapper mt-1"}>
                    <div className={"tag-inline-wrapper d-flex flex-wrap"}>
                      {(tags || []).map((item, index) => (
                        <SelectBox
                          index={index}
                          remove={false}
                          isSelect={dataForm.offerTitle.value === item.value}
                          select={true}
                          onClick={() => onSelect(item, index)}
                          // onRemove={() => onRemove(item, index)}
                          format={"text"}
                          text={item.value}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )} */}
              <Input
                elementConfig={dataForm.offerHeader.elementConfig}
                elementType={dataForm.offerHeader.elementType}
                required={dataForm.offerHeader.validation.required}
                isValid={!dataForm.offerHeader.valid}
                touched={dataForm.offerHeader.touched}
                value={dataForm.offerHeader.value}
                isShowRequired={true}
                size={"md"}
                margin={"m-b-2 mt-2"}
                label={dataForm.offerHeader.label}
                changed={(event) =>
                  inputHandleChange(event, dataForm.offerHeader.key)
                }
              />
              <Input
                elementConfig={dataForm.promoCode.elementConfig}
                elementType={dataForm.promoCode.elementType}
                required={dataForm.promoCode.validation.required}
                isValid={!dataForm.promoCode.valid}
                touched={dataForm.promoCode.touched}
                value={dataForm.promoCode.value}
                isShowRequired={true}
                size={"md"}
                margin={"m-b-2"}
                label={dataForm.promoCode.label}
                changed={(event) =>
                  inputHandleChange(event, dataForm.promoCode.key)
                }
              />
              <label>Description</label>
              <div className={"rich-text-editor-wrapper"}>
                <Editor
                  editorState={editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={onEditorStateChange}
                  toolbar={{
                    fontFamily: {
                      options: ["gothambook"],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                    fontSize: {
                      icon: undefined,
                      options: [11, 12, 13, 14, 18, 24],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                  }}
                />
              </div>
              {/* Offer rate */}
              <label className="mt-2">
                Offer rate <b> *</b>
              </label>
              {dataForm.offerType.elementConfig.options && (
                <>
                  <div className={"multiple-line-wrapper mt-1 mb-2"}>
                    <div className={"tag-inline-wrapper d-flex flex-wrap"}>
                      {(dataForm.offerType.elementConfig.options || []).map(
                        (item, index) => (
                          <SelectBox
                            key={index}
                            index={index}
                            remove={false}
                            isSelect={dataForm.offerType.value === item.value}
                            select={true}
                            onClick={() => onSelectOffer(item, index)}
                            onRemove={() => onRemove(dataForm.offerType.key)}
                            format={"text"}
                            text={item.value}
                          />
                        )
                      )}
                    </div>
                  </div>
                </>
              )}
              {dataForm.offerType.value && (
                <Input
                  elementConfig={dataForm.offerRate.elementType}
                  elementType={dataForm.offerRate.elementType}
                  required={dataForm.offerRate.validation.required}
                  isValid={!dataForm.offerRate.valid}
                  touched={dataForm.offerRate.touched}
                  value={dataForm.offerRate.value}
                  isShowRequired={false}
                  size={"md"}
                  margin={"m-b-2"}
                  label={
                    dataForm.offerType.value === "customize"
                      ? "Offer description"
                      : dataForm.offerRate.label +
                        "- " +
                        dataForm.offerType.value
                  }
                  changed={(event) =>
                    inputHandleChange(event, dataForm.offerRate.key)
                  }
                />
              )}

              {/* Offer validity */}
              <div className="mt-2 mb-3">
                <label>
                  Offer validity <b> *</b>
                </label>
                {dataForm.offerValidity.elementConfig.options && (
                  <>
                    <div className={"multiple-line-wrapper  mb-2"}>
                      <div className={"tag-inline-wrapper d-flex flex-wrap"}>
                        {(
                          dataForm.offerValidity.elementConfig.options || []
                        ).map((item, index) => (
                          <SelectBox
                            index={index}
                            remove={false}
                            isSelect={dataForm.offerValidity.value === item.key}
                            select={true}
                            onClick={() =>
                              onSelectOption(item, "offerValidity")
                            }
                            onRemove={() => onRemove("offerValidity")}
                            format={"text"}
                            text={item.value}
                          />
                        ))}
                      </div>
                    </div>
                  </>
                )}
                {dataForm.offerValidity.value === "until" && (
                  <div className={"mt-2"}>
                    <Input
                      elementConfig={dataForm.endDate.elementConfig}
                      elementType={dataForm.endDate.elementType}
                      required={dataForm.endDate.validation.required}
                      isValid={!dataForm.endDate.valid}
                      touched={dataForm.endDate.touched}
                      value={dataForm.endDate.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.endDate.label}
                      onChange={(event, date) =>
                        inputHandleChange(event, dataForm.endDate.key)
                      }
                    />

                    {selectMerchant && dataForm.endDate.dateValue != "" && (
                      <div className="mt-2">
                        <Tag
                          type={"pending"}
                          tagName={moment(dataForm.endDate.dateValue).format(
                            "DD-MM-YYYY"
                          )}
                        />
                      </div>
                    )}
                  </div>
                )}
                {dataForm.offerValidity.value === "till" && (
                  <div className={"mt-2"}>
                    <Input
                      elementConfig={dataForm.endDate.elementConfig}
                      elementType={dataForm.endDate.elementType}
                      required={dataForm.endDate.validation.required}
                      isValid={!dataForm.endDate.valid}
                      touched={dataForm.endDate.touched}
                      value={dataForm.endDate.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.endDate.label}
                      onChange={(event, date) =>
                        inputHandleChange(event, dataForm.endDate.key)
                      }
                    />

                    {selectMerchant && dataForm.endDate.dateValue != "" && (
                      <div className="mt-2">
                        <Tag
                          type={"pending"}
                          tagName={moment(dataForm.endDate.dateValue).format(
                            "DD-MM-YYYY"
                          )}
                        />
                      </div>
                    )}
                  </div>
                )}
                {dataForm.offerValidity.value === "on" && (
                  <div className={"mt-2"}>
                    <Input
                      elementConfig={dataForm.endDate.elementConfig}
                      elementType={dataForm.endDate.elementType}
                      required={dataForm.endDate.validation.required}
                      isValid={!dataForm.endDate.valid}
                      touched={dataForm.endDate.touched}
                      value={dataForm.endDate.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"m-b-2"}
                      label={"Valid date"}
                      onChange={(event, date) =>
                        inputHandleChange(event, dataForm.endDate.key)
                      }
                    />
                  </div>
                )}
                {dataForm.offerValidity.value === "fromTo" && (
                  <div className={"mt-2"}>
                    <Input
                      elementConfig={dataForm.startDate.elementConfig}
                      elementType={dataForm.startDate.elementType}
                      required={dataForm.startDate.validation.required}
                      isValid={!dataForm.startDate.valid}
                      touched={dataForm.startDate.touched}
                      value={dataForm.startDate.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"mb-1"}
                      label={dataForm.startDate.label}
                      onChange={(event, date) => {
                        inputHandleChange(event, dataForm.startDate.key);
                      }}
                    />
                    {selectMerchant && dataForm.startDate.dateValue != "" && (
                      <div className="mt-2">
                        <Tag
                          type={"pending"}
                          tagName={moment(dataForm.startDate.dateValue).format(
                            "DD-MM-YYYY"
                          )}
                        />
                      </div>
                    )}
                    <Input
                      elementConfig={dataForm.endDate.elementConfig}
                      elementType={dataForm.endDate.elementType}
                      required={dataForm.endDate.validation.required}
                      isValid={!dataForm.endDate.valid}
                      touched={dataForm.endDate.touched}
                      value={dataForm.endDate.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.endDate.label}
                      onChange={(event, date) =>
                        inputHandleChange(event, dataForm.endDate.key)
                      }
                    />

                    {selectMerchant && dataForm.endDate.dateValue != "" && (
                      <div className="mt-2">
                        <Tag
                          type={"pending"}
                          tagName={moment(dataForm.endDate.dateValue).format(
                            "DD-MM-YYYY"
                          )}
                        />
                      </div>
                    )}
                  </div>
                )}
                {dataForm.offerValidity.value === "customize" && (
                  <div className={"customize-date-wrapper " + ".mt-2"}>
                    <Input
                      elementConfig={dataForm.validDate.elementConfig}
                      elementType={dataForm.validDate.elementType}
                      required={dataForm.validDate.validation.required}
                      isValid={!dataForm.validDate.valid}
                      touched={dataForm.validDate.touched}
                      value={dataForm.validDate.value}
                      isShowRequired={true}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.validDate.label}
                      onChange={(event, date) =>
                        inputHandleChange(event, dataForm.validDate.key)
                      }
                    />
                    {selectMerchant && dataForm.validDate.dateValue != "" && (
                      <div className="mt-2">
                        <Tag
                          type={"pending"}
                          tagName={moment(dataForm.validDate.dateValue).format(
                            "DD-MM-YYYY"
                          )}
                        />
                      </div>
                    )}
                    <div className={"d-flex"}>
                      <div className={"col-6 pl-0 pr-0"}>
                        <Input
                          elementConfig={dataForm.startTime.elementConfig}
                          elementType={dataForm.startTime.elementType}
                          required={dataForm.startTime.validation.required}
                          isValid={!dataForm.startTime.valid}
                          touched={dataForm.startTime.touched}
                          value={dataForm.startTime.value}
                          isShowRequired={true}
                          size={"md"}
                          margin={"m-b-2"}
                          label={dataForm.startTime.label}
                          onChange={(event, date) =>
                            inputHandleChange(event, dataForm.startTime.key)
                          }
                        />
                        {selectMerchant &&
                          dataForm.startTime.timeValue != "" && (
                            <div className="mt-2">
                              <Tag
                                type={"pending"}
                                tagName={moment(
                                  dataForm.startTime.timeValue
                                ).format("DD-MM-YYYY")}
                              />
                            </div>
                          )}
                      </div>
                      <div className={"col-6 pr-0"}>
                        <Input
                          elementConfig={dataForm.endTime.elementConfig}
                          elementType={dataForm.endTime.elementType}
                          required={dataForm.endTime.validation.required}
                          isValid={!dataForm.endTime.valid}
                          touched={dataForm.endTime.touched}
                          value={dataForm.endTime.value}
                          isShowRequired={true}
                          size={"md"}
                          margin={"m-b-2"}
                          label={dataForm.endTime.label}
                          onChange={(event, date) =>
                            inputHandleChange(event, dataForm.endTime.key)
                          }
                        />
                        {selectMerchant && dataForm.endTime.timeValue != "" && (
                          <div className="mt-2">
                            <Tag
                              type={"pending"}
                              tagName={moment(
                                dataForm.endTime.timeValue
                              ).format("DD-MM-YYYY")}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <Input
                      elementConfig={
                        dataForm.validTimeDateDescription.elementConfig
                      }
                      elementType={
                        dataForm.validTimeDateDescription.elementType
                      }
                      required={
                        dataForm.validTimeDateDescription.validation.required
                      }
                      isValid={!dataForm.validTimeDateDescription.valid}
                      touched={dataForm.validTimeDateDescription.touched}
                      value={dataForm.validTimeDateDescription.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.validTimeDateDescription.label}
                      changed={(event) =>
                        inputHandleChange(
                          event,
                          dataForm.validTimeDateDescription.key
                        )
                      }
                    />
                  </div>
                )}
                {dataForm.offerValidity.value === "other" && (
                  <div className={"customize-date-wrapper " + ".mt-2"}>
                    <Input
                      elementConfig={dataForm.endDate.elementConfig}
                      elementType={dataForm.endDate.elementType}
                      required={dataForm.endDate.validation.required}
                      isValid={!dataForm.endDate.valid}
                      touched={dataForm.endDate.touched}
                      value={dataForm.endDate.value}
                      isShowRequired={true}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.endDate.label}
                      onChange={(event, date) =>
                        inputHandleChange(event, dataForm.endDate.key)
                      }
                    />

                    {merchantData && dataForm.endDate.dateValue != "" && (
                      <div className="mt-2">
                        <Tag
                          type={"pending"}
                          tagName={moment(dataForm.endDate.dateValue).format(
                            "DD-MM-YYYY"
                          )}
                        />
                      </div>
                    )}
                    <Input
                      elementConfig={
                        dataForm.validTimeDateDescription.elementConfig
                      }
                      elementType={
                        dataForm.validTimeDateDescription.elementType
                      }
                      required={
                        dataForm.validTimeDateDescription.validation.required
                      }
                      isValid={!dataForm.validTimeDateDescription.valid}
                      touched={dataForm.validTimeDateDescription.touched}
                      value={dataForm.validTimeDateDescription.value}
                      isShowRequired={false}
                      size={"md"}
                      margin={"m-b-2"}
                      label={dataForm.validTimeDateDescription.label}
                      changed={(event) =>
                        inputHandleChange(
                          event,
                          dataForm.validTimeDateDescription.key
                        )
                      }
                    />
                  </div>
                )}
              </div>
              {/* valid cards */}
              <div className={"bwpp__valid-cards mt-2"}>
                <div className={"d-flex flex-row justify-content-between"}>
                  <div className={"select-valid-card"}>
                    Select valid card type
                  </div>
                  <div className="d-flex flex-row-reverse">
                    <div
                      className={"add-new-action"}
                      onClick={() => {
                        if (bankData?.bankId) {
                          dispatch({
                            type: actionTypes.EDIT_BANK_CARD_TYPES,
                            payload: {
                              ...bankData,
                              cardTypes: cardTypes,
                            },
                          });
                        } else {
                          OpenNotification(
                            "Error",
                            "Please select a bank!",
                            "error"
                          );
                        }
                      }}
                    >
                      Add new
                    </div>
                    <div
                      className={`btn-refresh-btn sm mr-2`}
                      onClick={() => {
                        selectAllCardTypes();
                      }}
                    >
                      Select all
                    </div>
                  </div>
                </div>
                {cardTypes && cardTypes.length > 0 && (
                  <div className={"multiple-line-wrapper mb-2"}>
                    <div className={"tag-inline-wrapper d-flex flex-wrap"}>
                      {cardTypesList?.map((item, index) => (
                        <SelectionCheckbox
                          index={index}
                          remove={false}
                          isSelect={item.isActive}
                          select={true}
                          onClick={() => onSelectCard(item?.id)}
                          onRemove={() => onSelectCard(item?.id)}
                          format={"text"}
                          selectionName={item.cardName || item.value}
                        />
                      ))}

                      {cardTypes && cardTypes.length > 5 && (
                        <div
                          className="loading-more"
                          style={{ marginTop: showFull ? "5px" : "-24px" }}
                        >
                          <Button
                            text={showFull ? "Show Less" : "Show More.."}
                            size="sm"
                            type="btn-primary light"
                            onClick={() => {
                              setShowFull((prev) => {
                                if (prev) {
                                  // Going from "Show Full" -> "Show Less"
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  }); // matches transition time
                                }
                                return !prev;
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* location */}
              <div
                className={"bwpp__valid-locations"}
                style={{ marginTop: "12px" }}
              >
                <div className={"d-flex flex-row justify-content-between"}>
                  <div className={"select-valid-locations"}>
                    Select valid locations
                  </div>
                  <div className="d-flex flex-row-reverse">
                    <div
                      className={"add-new-action"}
                      onClick={() => {
                        if (merchantData?.merchantId) {
                          dispatch({
                            type: actionTypes.EDIT_MERCHANT_LOCATION,
                            payload: {
                              ...merchantData,
                              location: merchantLocationList,
                            },
                          });
                        } else {
                          OpenNotification(
                            "Error",
                            "Please select a merchant!",
                            "error"
                          );
                        }
                      }}
                    >
                      Add new
                    </div>
                    <div
                      className={`btn-refresh-btn sm mr-2`}
                      onClick={() => {
                        selectAllLocation();
                      }}
                    >
                      Select all
                    </div>
                  </div>
                </div>
                {merchantLocationList && merchantLocationList.length > 0 && (
                  <div className={"multiple-line-wrapper mb-2"}>
                    <div className={"tag-inline-wrapper d-flex flex-wrap"}>
                      {locationList.map((item, index) => (
                        <SelectionCheckbox
                          index={index}
                          remove={false}
                          isSelect={item.isActive}
                          select={true}
                          onClick={() => onSelectLocation(item?.id)}
                          onRemove={() => onSelectLocation(item?.id)}
                          format={"text"}
                          selectionName={
                            item.value || item.cardName || item.tagName
                          }
                        />
                      ))}
                      {merchantLocationList?.length > 4 && (
                        <div
                          className="loading-more"
                          style={{
                            marginTop: showFullLocation ? "5px" : "-24px",
                          }}
                        >
                          <Button
                            text={
                              showFullLocation ? "Show Less" : "Show More.."
                            }
                            size="sm"
                            type="btn-primary light"
                            onClick={() => {
                              setShowFullLocation((prev) => {
                                if (prev) {
                                  // Going from "Show Full" -> "Show Less"
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  }); // matches transition time
                                }
                                return !prev;
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* contacts */}
              <div
                className={"bwpp__reservation"}
                style={{ marginTop: "12px" }}
              >
                <div className={"d-flex flex-row justify-content-between"}>
                  <div className={"reservation-contacts"}>
                    Reservation contacts
                  </div>
                  <div
                    className={"add-new-action"}
                    onClick={async () => {
                      if (merchantData?.merchantId) {
                        const resMerchant = await cooFindMerchantById(
                          merchantData?.merchantId
                        );
                        let selectMerchant = resMerchant?.data?.data;
                        dispatch({
                          type: actionTypes.EDIT_OFFER_CONTACTS,
                          payload: {
                            ...selectMerchant,
                            hotLine: {
                              mobileNo: selectMerchant?.hotLine?.mobileNo || [],
                              email: selectMerchant?.hotLine?.email || [],
                            },
                          },
                        });
                      } else {
                        OpenNotification(
                          "Error",
                          "Please select a merchant!",
                          "error"
                        );
                      }
                    }}
                  >
                    Add new
                  </div>
                </div>
                {merchantData?.merchantId && (
                  <>
                    <div className="d-flex flex-column">
                      <label className={"label-validation-on"}>Mobile No</label>
                      {mobileNoList?.length > 0 ? (
                        <div className={"multiple-line-wrapper"}>
                          <div
                            className={"tag-inline-wrapper d-flex flex-wrap"}
                          >
                            {mobileNoList.map((mobile, index) => (
                              // <div key={index}>{email.contact}</div>
                              <SelectBox
                                index={index}
                                remove={false}
                                isSelect={mobile?.isActive}
                                select={true}
                                onClick={() => {
                                  const updatedMobileList = mobileNoList.map(
                                    (item, i) => {
                                      if (i === index) {
                                        return {
                                          ...item,
                                          isActive: !item.isActive,
                                        };
                                      }
                                      return item;
                                    }
                                  );
                                  setMobileNoList(updatedMobileList);
                                }}
                                format={"text"}
                                text={mobile.contact}
                              />
                            ))}
                          </div>
                        </div>
                      ) : (
                        "-"
                      )}
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <label className={"label-validation-on"}>email</label>
                      {emailList?.length > 0 ? (
                        <div className={"multiple-line-wrapper"}>
                          <div
                            className={"tag-inline-wrapper d-flex flex-wrap"}
                          >
                            {emailList.map((email, index) => (
                              // <div key={index}>{email.contact}</div>
                              <SelectBox
                                index={index}
                                remove={false}
                                isSelect={email?.isActive}
                                select={true}
                                onClick={() => {
                                  const updatedEmailList = emailList.map(
                                    (item, i) => {
                                      if (i === index) {
                                        return {
                                          ...item,
                                          isActive: !item.isActive,
                                        };
                                      }
                                      return item;
                                    }
                                  );
                                  setEmailList(updatedEmailList);
                                }}
                                onRemove={() => {
                                  // if (email.contact) {
                                  //  setState({
                                  //     emailList: emailList.filter(
                                  //       (item, i) => i !== index
                                  //     ),
                                  //   });
                                  // }
                                }}
                                format={"text"}
                                text={email.contact}
                              />
                            ))}
                          </div>
                        </div>
                      ) : (
                        "-"
                      )}
                    </div>
                  </>
                )}
              </div>
              {/* terms */}
              <div className="bwpp_reservation mb-4">
                <div className={"d-flex flex-row justify-content-between mb-2"}>
                  <div className={"select-valid-card"}>Manage Terms</div>
                  <div className="d-flex flex-row-reverse">
                    <div
                      className={"add-new-action"}
                      onClick={async () => {
                        let terms;
                        const bankId = bankData.bankId;
                        if (merchantData === "") {
                          OpenNotification(
                            "Error",
                            "Please select a bank!",
                            "error"
                          );
                          return;
                        }
                        if (
                          Array.isArray(merchantData?.termsAndCondition) &&
                          merchantData?.termsAndCondition.length > 0
                        ) {
                          const termsList = merchantData?.termsAndCondition;
                          console.log("termsList", termsList);

                          terms = termsList;
                        } else if (
                          merchantData?.termsAndCondition?.[bankData?.bankId] &&
                          merchantData?.termsAndCondition?.[bankData?.bankId]
                            ?.length !== termsAndConditions?.length
                        ) {
                          let merchant = merchantList?.find(
                            (x) => x.id === merchantData?.merchantId
                          );

                          // Retrieve or initialize the terms object for the selected bank
                          terms = merchant?.termsAndCondition || {};

                          if (!terms[bankId]) {
                            terms[bankId] = [];
                          }

                          // Set to keep track of unique term IDs
                          const uniqueTermIds = new Set(
                            terms[bankId].map((term) => term.id)
                          );
                          // Filter termsAndConditions, adding only new terms
                          const nonDuplicateTerms = termsAndConditions?.filter(
                            (term) => !uniqueTermIds.has(term.id)
                          );

                          // Add new terms (non-duplicates) to the existing bank's terms
                          terms[bankId].push(...nonDuplicateTerms);
                        } else {
                          terms = merchantData?.termsAndCondition || {};
                        }

                        const termsToAdd = {
                          bankId: bankData?.bankId,
                          terms: terms,
                        };
                        // Trigger the functions with the prepared data
                        if (
                          Array.isArray(merchantData?.termsAndCondition) &&
                          merchantData?.termsAndCondition.length > 0
                        ) {
                          const termsList = merchantData?.termsAndCondition;
                          console.log("termsList", termsList);

                          termsList.forEach((term) => {
                            dispatch({
                              type: actionTypes.ADD_NEW_TERMS_INTO_LIST,
                              payload: {
                                parts: term,
                                bankId,
                              },
                            });
                          });
                        } else {
                          dispatch({
                            type: actionTypes.SELECTED_EXISTING_TERMS,
                            payload: termsToAdd,
                          });
                        }
                        dispatch({
                          type: actionTypes.SET_SELECTED_BANK,
                          payload: bankData,
                        });
                        dispatch({
                          type: actionTypes.OPEN_TERMS_AND_CONDITIONS_MODAL,
                        });
                        dispatch({
                          type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL,
                          payload: merchantData,
                        });
                        // this.props.onClickAddTermsIntoList(termsToAdd);
                        // this.props.onClickOpenTermsAndConditions();
                      }}
                    >
                      Add new
                    </div>
                    <div
                      className={`btn-refresh-btn sm mr-2`}
                      onClick={() => {
                        selectAllTerms();
                      }}
                    >
                      Select all
                    </div>
                  </div>
                </div>
                {merchantData?.merchantId && (
                  <Tabs defaultActiveKey="1">
                    <TabPane tab={bankData?.bankName} key={bankData?.bankId}>
                      {termsAndConditions && (
                        <>
                          <div className={"multiple-line-wrapper mt-1"}>
                            <div
                              className={"tag-inline-wrapper d-flex flex-wrap"}
                            >
                              {(termsAndConditions || []).map((item, index) => (
                                <SelectBox
                                  index={index}
                                  remove={false}
                                  isSelect={item.isActive}
                                  select={true}
                                  onClick={() =>
                                    onClickTermsAndConditions(index)
                                  }
                                  format={"text"}
                                  text={item.value}
                                />
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </TabPane>
                  </Tabs>
                )}
              </div>
            </Scrollbars>
          </div>{" "}
          <div
            className="d-flex flex-row justify-content-between pt-4"
            style={{ width: "100%" }}
          >
            {(merchantData?.merchantId || categoryData?.categoryId) && (
              <div className={"mr-2"}>
                <Button
                  leftIcon={false}
                  rightIcon={false}
                  disabled={false}
                  isLoading={isLoading || isImageUploading}
                  isActiveAnimation={false}
                  reactRightIcon={GetIcon("close")}
                  onClick={async () => {
                    await clearAll();
                  }}
                  text={"Cancel"}
                  size={"md"}
                  type={"btn-block-back-secondary"}
                />
              </div>
            )}

            <Button
              leftIcon={false}
              rightIcon={false}
              disabled={
                !merchantData?.merchantId ||
                !bankData?.bankId ||
                !categoryData?.categoryId
              }
              isLoading={isLoading || isImageUploading}
              isActiveAnimation={false}
              reactRightIcon={GetIcon("leftArrow")}
              onClick={async () => {
                await onClickSaveData();
              }}
              text={"Review"}
              size={"md"}
              type={"btn-block-back"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setValue,
  };
};

export default connect(null, mapDispatchToProps)(SampathBankOffers);
